import { getLocalizedParamLabel, getLocalizedParamTitle } from "./utils";

const ParamText = ({ param, labelClassName, valueClassName }) => {
    const [, value] = param.split("=", 2);
    const localizedLabel = getLocalizedParamLabel(param);
    const localizedTitle = getLocalizedParamTitle(param, localizedLabel);
    return (
        <>
            <span className={labelClassName} title={localizedTitle}>
                {localizedLabel}
            </span>
            :{" "}
            <span className={valueClassName} title={value}>
                {value}
            </span>
        </>
    );
};

ParamText.displayName = "SearchParam.Text";
export default ParamText;
